import {CategoryTypeVo} from '../../common/shared/api/nicolas/vo/enums/CategoryTypeVo.enum';
import {CategoryType} from '../generated/types';

export function createCategoryType(
  categoryTypeVo?: CategoryTypeVo
): CategoryType {
  if (!categoryTypeVo) {
    return CategoryType.Unknown;
  }
  return map[categoryTypeVo] || CategoryType.Unknown;
}

const map: {[key in CategoryTypeVo]: CategoryType} = {
  [CategoryTypeVo.Cartoon]: CategoryType.Webtoon,
  [CategoryTypeVo.Novel]: CategoryType.Webnovel,
  [CategoryTypeVo.Book]: CategoryType.Book,
  [CategoryTypeVo.TalkDrip]: CategoryType.TalkDrip,
  [CategoryTypeVo.KatalkNovel]: CategoryType.KatalkNovel,
  [CategoryTypeVo.None]: CategoryType.Unknown,
  [CategoryTypeVo.Broadcast]: CategoryType.Unknown,
  [CategoryTypeVo.Movie]: CategoryType.Unknown,
};
